import React from 'react'

function Home() {
  return (
    <div style={{width:"100%",height:window.innerHeight,display:"flex",justifyContent:"center",alignItems:"center",background: " linear-gradient(0deg, rgba(221,94,237,1) 9%, rgba(118,49,141,1) 56%)"}}>
  <p style={{
    fontSize: '120px',
    textAlign: 'center',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: "'Steelfish Rg', 'helvetica neue', helvetica, arial, sans-serif",
    WebkitFontSmoothing: 'antialiased',}}>Flash Date</p>
    </div>
  )
}

export default Home